export enum INgxChatUiMessageType{
  text,
  select,
  autocomplete,
  upload,
  dialogEnd
}
